import meetingsService from "../services/meetings.service";
import store from "../store/mainStore";
import SessionService from "../services/session.service"
import AiGeneratorService from "../services/ai.generator.service";
import ProtocolService from "../services/protocol.service";
import router from "../router/main-router.js"
import AlertHelper from '@/helpers/alerts.helper.js';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import i18n from '../helpers/i18n.helper.js';
import { getResidentPortalSessionUrl } from '../helpers/residentPortal.helper.js';

export const meetingsActions = [
    {
        id: 0,
        action: "sessionEdit",
        name: 'com.file.meeting-actions.session-edit',
        icon: "edit-session-list",
        link: "sessions",
        handler: () => { },
    },
    //{
    //    id: 1,
    //    action: "sessionInteractive",
    //    name: "Tryb sesji interaktywnej",
    //    icon: "display",
    //    handler: () => {},
    //},
    {
        id: 10,
        action: "",
        name: 'com.file.meeting-actions.session-settings',
        icon: "settings",
        handler: (id) => {
            store.commit("showEditMeeting", id);
        },
    },
    //{
    //    id: 3,
    //    action: "",
    //    name: "Przygotuj zaproszenia na posiedzenie",
    //    icon: "wallet",
    //    handler: () => {},
    //},

    {
        id: 15,
        action: "",
        name: 'com.file.meeting-actions.session-next',
        icon: "rotate-right",
        handler: async (id) => {
            try {
                store.commit("showLoader");
                let result = await SessionService.getNextPreviousSessionId(id, 2);
                if (result.status === 200) {
                    var s = result.data;
                    if (s > 0) {
                        var url = window.location.href.split(`sessions/${id}/`);
                        if (url.length > 0) {
                            router.push({ name: "sessionEdit", params: { sessionid: s, groupid: url[1] } });
                        }
                    }
                }
            }
            finally {
                store.commit("hideLoader");
            }
        }
    },

    {
        id: 16,
        action: "",
        name: 'com.file.meeting-actions.session-back',
        icon: "rotate-left",
        handler: async (id) => {
            try {
                store.commit("showLoader");
                let result = await SessionService.getNextPreviousSessionId(id, 1);
                if (result.status === 200) {
                    var s = result.data;
                    if (s > 0) {
                        var url = window.location.href.split(`sessions/${id}/`);
                        if (url.length > 0) {
                            router.push({ name: "sessionEdit", params: { sessionid: s, groupid: url[1] } });
                        }
                    }
                }
            }
            finally {
                store.commit("hideLoader");
            }
        }
    },

    {
        id: 20,
        action: "",
        name: 'com.file.meeting-actions.presence-list',
        icon: "user-check-presence",
        handler: async (id) => {
            try {
                store.commit("showLoader");
                store.commit('showPresenceList', id);
            }
            finally {
                store.commit("hideLoader");
            }
        }
    },

    {
        id: 30,
        action: "",
        name: 'com.file.meeting-actions.save-as-template',
        icon: "save",
        handler: async (id) => {
            try {
                store.commit("showLoader");
                const result = await SessionService.saveSessionAsTemplate(id);
                if (result.status !== 200) {
                    throw await Promise.reject(result);
                }
                const response = await SessionService.getSessionTemplate();
                if (response.status !== 200) {
                    throw await Promise.reject(response);
                }
                store.state.appStore.sessionTemplates = response.data;
                const toastSuccess = Swal.mixin(AlertHelper.informationSuccessElement());
                toastSuccess.fire(AlertHelper.successAlert(i18n.global.t('com.file.meeting-actions.save-as-template-success'), i18n.global.t('com.global.success')));
            }
            catch{
                const toastError = Swal.mixin(AlertHelper.errorToastElement());
                toastError.fire(AlertHelper.errorAlert(i18n.global.t('com.file.meeting-actions.save-as-template-error'), i18n.global.t('com.global.error')));
            }
            finally {
                store.commit("hideLoader");
            }
        }
    },
    {
        id: 40,
        action: "",
        name: 'com.file.meeting-actions.duplicate-session',
        icon: "duplicate",
        handler: (id) => {
            store.commit("showDuplicateSession", id);
        }
    },
    {
        id: 50,
        action: "",
        name: 'com.file.meeting-actions.get-protocol',
        icon: "download",
        handler: async (id) => {
            try {
                store.commit("showLoader");
                let result = await SessionService.getExportedSessionProtocolToWord(id);
                if (result.status == 200) {
                    const contentType = result.headers['content-type'];
                    let a = document.createElement('a');
                    var blob = new Blob([result.data], { 'type': contentType });
                    a.href = window.URL.createObjectURL(blob);
                    var filename = result.headers['content-disposition'].split("filename=")[1];

                    filename = filename.substr(0, filename.indexOf(';'));
                    filename = filename.replaceAll('"', '');
                    a.download = filename
                    a.click();
                }
            }
            finally {
                store.commit("hideLoader");
            }
        },
    },
    {
        id: 51,
        action: "",
        name: "com.file.meeting-actions.generate-protocol-ai",
        icon: "robot",
        handler: async (id) => {
            try {
                store.commit("showLoader");

                let result_1 = await ProtocolService.getProtocolsData(id);
                if (result_1.status == 200 && result_1.data.isTranscriptionAvailable !== null && result_1.data.isTranscriptionAvailable === true) {

                    var result = await AiGeneratorService.generateAiSessionProtocol(id);

                    if (result.status == 200) {
                        const contentType = result.headers['content-type'];
                        let a = document.createElement('a');
                        var blob = new Blob([result.data], { 'type': contentType });
                        a.href = window.URL.createObjectURL(blob);
                        var filename = result.headers['content-disposition'].split("filename=")[1];

                        filename = filename.substr(0, filename.indexOf(';'));
                        filename = filename.replaceAll('"', '');
                        a.download = filename
                        a.click();

                        var t = Swal.mixin(AlertHelper.informationSuccessElement());
                        t.fire(AlertHelper.successAlert(i18n.global.t('com.file.meeting-actions.generate-protocol-ai-success'), i18n.global.t('com.global.success')));
                    }
                    else {
                        var t1 = Swal.mixin(AlertHelper.errorToastElement());
                        t1.fire(AlertHelper.errorAlert(i18n.global.t('com.file.meeting-actions.generate-protocol-ai-error'), i18n.global.t('com.global.error')));
                    }
                }
                else {
                    var t3 = Swal.mixin(AlertHelper.errorToastElement());
                    t3.fire(AlertHelper.errorAlert(i18n.global.t('com.file.meeting-actions.generate-protocol-ai-no-transcription'), i18n.global.t('com.global.error')));
                }
            }
            catch {
                var t2 = Swal.mixin(AlertHelper.errorToastElement());
                t2.fire(AlertHelper.errorAlert(i18n.global.t('com.file.meeting-actions.generate-protocol-ai-error'), i18n.global.t('com.global.error')));
            }
            finally {
                store.commit("hideLoader");
            }
        },
    },
    {
        id: 60,
        action: "",
        name: 'com.file.meeting-actions.add-protocol',
        icon: "add-protocol",
        handler: (id) => {
            store.commit("showAddProtocol", id);
        },
    },
    {
        id: 64,
        action: "",
        name: 'com.file.meeting-actions.create-meeting-invitation',
        icon: "pen-to-square",
        handler: (id) => {
            store.commit("setPrepareMeetingInvitationModalSessionId", id);
            store.commit("setPrepareMeetingInvitationModalStatus", true);
        },
    },
    {
        id: 65,
        action: "",
        name: 'com.file.meeting-actions.send-session-materials',
        icon: "paper-plane-top-regular",
        handler: (id) => {
            store.commit("setSendMeetingRegardingModalSessionId", id);
            store.commit("setSendMeetingRegardingModalStatus", true);
        },
    },

    {
        id: 67,
        action: "",
        name: 'com.file.meeting-actions.play-audio',
        icon: "play",
        handler: async (id) => {
            try {
                store.commit("showLoader");
                let result = await SessionService.getSessionCodeToRecorded(id);
                if (result.status == 200 && result.data != null) {
                    var url = "https://ssl.esesja.pl/player/" + id + "/" + result.data;
                    window.open(url, "_blank");
                }
                else {
                    var t = Swal.mixin(AlertHelper.informationToastElement());
                    t.fire(AlertHelper.informationAlert(i18n.global.t('com.file.meeting-actions.no-play-audio-alert'), i18n.global.t('com.global.info')));
                }
            }
            catch {
                var t1 = Swal.mixin(AlertHelper.informationToastElement());
                t1.fire(AlertHelper.informationAlert(i18n.global.t('com.file.meeting-actions.no-play-audio-alert'), i18n.global.t('com.global.info')));
            }
            finally {
                store.commit("hideLoader");
            }
        },
    },

    {
        id: 68,
        action: "",
        name: 'com.file.meeting-actions.record-audio',
        icon: "record-vinyl",
        handler: () => {
            store.commit('setRecorderOpenStatus', true);
        },
    },

    {
        id: 69,
        action: "",
        name: 'com.file.meeting-actions.publish-record-audio',
        icon: "video-arrow-up-right",
        handler: (id) => {
            store.commit("setAudioVideoLinkSessionId", id);
            store.commit("setAudioVideoLinkModalStatus", true);
        },
    },

    {
        id: 70,
        action: "",
        name: 'com.file.meeting-actions.export-agenda',
        icon: "export-to-doc",
        handler: async (id) => {
            try {
                store.commit("showLoader");
                let result = await SessionService.getExportedSessionToWord(id);
                if (result.status === 200) {
                    const contentType = result.headers['content-type'];
                    let a = document.createElement('a');
                    var blob = new Blob([result.data], { 'type': contentType });
                    a.href = window.URL.createObjectURL(blob);
                    var filename = result.headers['content-disposition'].split("filename=")[1];

                    filename = filename.substr(0, filename.indexOf(';'));
                    filename = filename.replaceAll('"', '');
                    a.download = filename
                    a.click();
                }
            }
            finally {
                store.commit("hideLoader");
            }
        },
    },
    {
        id: 75,
        action: "",
        name: 'com.file.meeting-actions.voting-report',
        icon: "download",
        handler: (id) => {
            store.commit("showVotingReportSettings", id);
        }
    },
    {
        id: 80,
        action: "",
        name: 'com.file.meeting-actions.import-agenda',
        icon: "export-to-doc",
        handler: (id) => {
            store.commit("showImportSessionAgenda", id);
        }
    },
    {
        id: 90,
        action: "",
        name: 'com.file.meeting-actions.show-session-metrics',
        icon: "timer",
        handler: (id) => {
            store.commit("showSessionMetadata", id);
        },
    },
    {
        id: 95,
        action: "",
        name: 'com.file.meeting-actions.export-votings-bip',
        icon: "bip-simple",
        handler: (id) => {
            const actionToFire = () => {
                store.commit("showLoader");
                SessionService.exportSessionVotingsToBip(id).then((response) => {
                    store.commit("hideLoader");

                    if (response.status == 200) {
                        store.commit("showSuccess");
                    }
                    else {
                        store.commit("showError");
                    }

                }).catch(() => {
                    store.commit("hideLoader");
                });
            };
            store.commit("showConfirmationAlert", actionToFire);
        },
    },
    {
        id: 97,
        action: "",
        name: 'com.file.meeting-actions.open-resident-portal',
        icon: "building-columns",
        getUrl: (session) => getResidentPortalSessionUrl(store.state.userStore.residentPortal, session?.is_public, session?.code),
        handler: () => { },
    },
    {
        id: 96,
        action: "",
        name: 'com.file.meeting-actions.camera-control',
        icon: "camera-web",
        handler: async (id) => {
            try {
                store.commit("showLoader");
                let result = await SessionService.getCameraTokenSSO(id);
                if (result.status == 200) {
                    const scheme = store.state.settings.client.cameraAddressScheme === 10 ? 'https' : 'http';
                    var url = `${scheme}://${store.state.settings.client.cameraApiAddress}:${store.state.settings.client.cameraApiAddressPort}/${result.data}`;
                    window.open(url, "_blank");
                }
            }
            finally {
                store.commit("hideLoader");
            }
        },
    },

    {
        id: 98,
        action: "",
        name: 'com.file.meeting-actions.open-session',
        icon: "lock-open",
        handler: async (id) => {
            const actionToFire = () => {
                store.commit("showLoader");
                SessionService.unlockSelectedSession(id).then((response) => {
                    store.commit("hideLoader");

                    if (response.status == 200) {

                        meetingsService.groups(false).then((response) => {
                            store.commit("setGroups", response.data)
                        });

                        store.commit("showSuccess");
                        store.commit("setUnlockSessionStatus", true);
                    }
                    else {
                        store.commit("showError");
                    }

                }).catch(() => {
                    store.commit("hideLoader");
                });
            };
            store.commit("showConfirmationAlert", actionToFire);
        },
    },

    {
        id: 99,
        action: "",
        name: 'com.file.meeting-actions.close-session',
        icon: "lock",
        handler: async (id) => {
            const actionToFire = () => {
                store.commit("showLoader");
                SessionService.lockSelectedSession(id).then((response) => {
                    store.commit("hideLoader");

                    if (response.status == 200) {

                        meetingsService.groups(false).then((response) => {
                            store.commit("setGroups", response.data)
                        });

                        store.commit("showSuccess");
                        store.commit("setLockSessionStatus", true);
                    }
                    else {
                        store.commit("showError");
                    }

                }).catch(() => {
                    store.commit("hideLoader");
                });
            };
            store.commit("showConfirmationAlert", actionToFire);
        },
    },

    {
        id: 100,
        action: "",
        name: 'com.file.meeting-actions.delete-session',
        icon: "delete",
        handler: (id) => {
            const actionToFire = () => {
                store.commit("showLoader");
                meetingsService.removeSession(id).then(() => {

                    meetingsService.groups(false).then((response) => {
                        store.commit("setGroups", response.data)
                    });

                    store.commit("hideLoader");
                    store.commit("showSuccess");
                    store.commit("setSessionDeletedStatus", true);

                }).catch(() => {
                    store.commit("hideLoader");
                });
            };
            store.commit("showConfirmationAlert", actionToFire);
        },
    },
];
